// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1vQrT","alert":"SettungsInbox_alert__34jLD"};